export default {"src":"/_next/static/media/section8-img.37cea3d1.svg","height":278,"width":677,"blurWidth":0,"blurHeight":0};